import TextField from "@mui/material/TextField";
import Box from "@mui/material/Box";
import * as theme from '../../../theme';

export default function AccountCredentials({ formData, handleChange, passwordStrength, passwordMatchError, error, clearError }) {
  return (
    <Box sx={{ ...theme.FullForm.form, gap: 4 }}>
      <TextField
        label="Email"
        name="email"
        type="email"
        value={formData.email}
        onChange={handleChange}
        variant="filled"
        required
        fullWidth
        error={!!error && error.includes('email')}
        helperText={error && error.includes('email') ? error : ''}
      />
      <TextField
        label="Password"
        name="password"
        type="password"
        value={formData.password}
        onChange={handleChange}
        variant="filled"
        required
        fullWidth
        helperText={passwordStrength ? `Strength: ${passwordStrength}` : 'Minimum 8 characters, include uppercase, lowercase, number, symbol for strong password.'}
      />
      <TextField
        label="Confirm Password"
        name="confirmPassword"
        type="password"
        value={formData.confirmPassword}
        onChange={handleChange}
        variant="filled"
        required
        fullWidth
        error={!!passwordMatchError}
        helperText={passwordMatchError}
      />
    </Box>
  );
}